import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import { startRoutePathHistHandlerTimer, clearRoutePathHistHandlerTimer } from '@/utils/router';

/**
 * routeByTab → watch $route → changeActiveTab
 * @type {[type]}
 */
export default {
  data() {
    return {
      tabs: {},
      activeTabName: '_',
      activeTab: {},
      isRoutedByTmpActiveTab: false,
      /**
       * 라우트 경로 이력 핸들러 타이머
       * @type {Number}
       */
      routePathHistHandlerTimer: null,
    };
  },
  computed: {
    /**
     * 선택된 메뉴 아이디
     * @author Ju
     * @return {String} 선택된 메뉴의 아이디
     */
    selectedMenuUrl() {
      return this.$store.getters.selectedMenu.url;
    },
    tmpActiveTab() {
      return this.$store.state.router.tmpActiveTab;
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(to, from) {
        console.info('[Tab]----- watch $route ------------');
        console.info(`  FROM: ${from ? from.path : null}`);
        console.info(`  TO: ${to ? to.path : null}`);
        if (isEmpty(to.params.activeTab)) {
          this.routeByDefaultTab();
        } else {
          const toActiveTab = to.params.activeTab;
          if (isEmpty(from)) {
            this.$nextTick(() => {
              this.changeActiveTab(toActiveTab);
              this.$router.replace({
                path: this.$route.path,
                params: this.$route.params,
              });
            });
          } else {
            const fromActiveTab = from.params.activeTab;

            // const toMenu = to.path.split('/')[1];
            // const fromMenu = from.path.split('/')[1];

            // 메뉴 변경 X
            // const replaceFlag = false;
            // if (fromMenu === toMenu) {
            //   const toTreeKey = to.params.treeKey;
            //   const fromTreeKey = from.params.treeKey;
            //
            //   // activeTab y > n으로 바뀔 경우 불필요한 history이므로 대체시키도록 한다 // router.replace
            //   if (toTreeKey === fromTreeKey && !isEmpty(fromActiveTab)) {
            //     replaceFlag = true;
            //   }
            // }
            console.info('------------------------------------- 3. Tab-------------------------------------------------');
            console.info(`change route from (${from.path}): ${from.path.split('/')[1]} / ${from.params.treeKey} / ${fromActiveTab}`);
            console.info(`change route To (${to.path}): ${to.path.split('/')[1]} / ${to.params.treeKey} / ${toActiveTab}`);
            console.info('-----------------------------------------------------------------------------------------');
            this.$nextTick(() => {
              console.info('active tab');
              this.changeActiveTab(toActiveTab);
            });
          }
        }
      },
    },
    activeTabName(to, from) {
      console.info('[Tab]----- watch activeTabName ------------');
      console.info(`  route: ${this.$route ? this.$route.path : null}`);
      console.info(`  activeTabName: ${to}`);

      if (isEmpty(this.activeTabName) || to === '_') {
        let activeTabName = null;
        if (isEmpty(this.$route.params.activeTab)) {
          const defaultTab = this.findDefaultTab(this.tabs);
          activeTabName = defaultTab.name;
        } else {
          activeTabName = this.$route.params.activeTab;
        }
        this.routeByTab(activeTabName, true);
      } else {
        this.routeByTab(to, false);
      }
    },
    tmpActiveTab: {
      immediate: true,
      handler(to) {
        console.info('[Tab]----- watch tmpActiveTab ------------');
        console.info(`  route: ${this.$route ? this.$route.path : null}`);
        console.info(`  tmpActiveTab: ${to}`);
        if (!isEmpty(to)) {
          if (!this.isRoutedByTmpActiveTab) {
            this.$store.dispatch('setTmpActiveTab', null);
            this.isRoutedByTmpActiveTab = true;
            this.routeByTab(to, true);
          } else {
            this.$store.dispatch('setTmpActiveTab', null);
          }
        }
      },
    },
  },
  // mounted() {
  //   // 화면 초기 로드 시 활성화 탭 정보가 없으면 현재 activeTab 기준으로 라우팅되도록 함.
  //   // 탭 정보가 있다면 activeTab에 해당 정보 설정
  //   if (isEmpty(this.$route.params.activeTab)) {
  //     const defaultTab = this.findDefaultTab(this.tabs);
  //     this.routeByTab(defaultTab.name, true);
  //   } else {
  //     // this.changeActiveTab(this.$route.params.activeTab);
  //     this.routeByTab(this.$route.params.activeTab);
  //   }
  // },
  methods: {
    /**
     * 활성화된 탭 객체를 찾는다.
     * @author Ju
     * @param  {[type]} tabs [description]
     * @return {[type]}      [description]
     */
    findActiveTab(tabs) {
      let activeTab = null;
      forEach(tabs, (tab) => {
        if (tab.active === true) {
          activeTab = tab;
        }
      });
      return activeTab;
    },
    /**
     * 기본 탭을 찾는다.
     * @author Ju
     * @param  {[type]} tabs [description]
     * @return {[type]}      [description]
     */
    findDefaultTab(tabs) {
      let defaultTab = null;
      forEach(tabs, (tab) => {
        if (tab.default === true) {
          defaultTab = tab;
        }
      });
      return defaultTab;
    },
    /**
     * 탭을 비활성화 시킨다.
     * @author Ju
     * @param  {[type]} tabs          [description]
     * @param  {[type]} exceptTabName [비활성화하지 않을 탭 이름]
     * @return {[type]}               [description]
     */
    deactivateTabs(tabs, exceptTabName) {
      forEach(tabs, (tab) => {
        if (tab.name !== exceptTabName) {
          tab.active = false;
        }
      });
    },
    changeActiveTab(activeTabName) {
      console.info('[Tab]----- changeActiveTab ------------');
      console.info(`  route: ${this.$route ? this.$route.path : null}`);
      console.info(`  tab: ${activeTabName}`);
      const tab = this.tabs[activeTabName];
      if (isEmpty(tab) || this.isDisabledTab(activeTabName)) {
        this.routeByDefaultTab();
      } else {
        this.deactivateTabs(this.tabs, activeTabName);
        tab.active = true;
        this.activeTab = tab;
        this.activeTabName = tab.name;
        this.$store.dispatch('setActiveTab', tab);
        clearRoutePathHistHandlerTimer(this.routePathHistHandlerTimer);
        this.routePathHistHandlerTimer = startRoutePathHistHandlerTimer(this, this.$route.path);
      }
    },
    routeByDefaultTab() {
      console.info('[Tab]----- routeByDefaultTab ------------');
      console.info(`  route: ${this.$route ? this.$route.path : null}`);
      const defaultTabName = this.findDefaultTab(this.tabs).name;
      this.routeByTab(defaultTabName, true);
    },
    routeByTab(activeTabName, replaceFlag) {
      /* eslint-disable no-param-reassign */
      console.info('[Tab]----- routeByTab ------------');
      console.info(`  route: ${this.$route ? this.$route.path : null}`);
      console.info(`  mouve: ${activeTabName}`, this.$options.name);
      if (isEmpty(this.tabs[activeTabName])) {
        activeTabName = this.findDefaultTab(this.tabs).name;
        replaceFlag = true;
      }

      if ((this.activeTab.name !== activeTabName) || (this.$route.activeTab !== activeTabName)) {
        let location;
        const menuUrl = isNil(this.selectedMenuUrl) ? this.$route.path.split('/')[1] : this.selectedMenuUrl;
        const treeKey = this.$route.params.treeKey;
        if (isEmpty(treeKey)) {
          location = {
            path: `/${menuUrl}/${activeTabName}`,
            params: {
              activeTab: activeTabName,
            },
          };
        } else {
          location = {
            path: `/${menuUrl}/${treeKey}/${activeTabName}`,
            params: {
              treeKey,
              actvieTab: activeTabName,
            },
          };
        }
        if (replaceFlag === true) {
          this.$router.replace(location);
        } else {
          this.$router.push(location);
        }
        /* eslint-enable no-param-reassign */
      }
    },
    /* override */
    /* eslint-disable no-unused-vars */
    /**
     * 사용할 수 없는 탭인지 확인한다.
     * 조건에 따라 탭에서 동적으로 탭 사용 여부가 결정될 경우 이를 고려하여 override하여
     * 선택될 수 없는 탭일 경우 true를 반환하도록 한다.
     * @author Ju
     * @param  {[type]}  tabName [description]
     * @return {Boolean}         [description]
     */
    isDisabledTab(tabName) {
      return false;
    },
    /* eslint-enable no-unused-vars */
  },
};



// WEBPACK FOOTER //
// ./src/mixins/router/tab.js